import { StandardEvents } from '@shopify/events';

const LIVE_SYNC_FLAG = '__nklvProductLiveSyncV3';

if (!window[LIVE_SYNC_FLAG]) {
  window[LIVE_SYNC_FLAG] = true;

  let fetchTimer = 0;
  let activeRequest = null;
  let fetchQueued = false;

  const cartUrl = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root + 'cart.js';
  };

  const sumItems = (items) =>
    Array.isArray(items)
      ? items.reduce((total, item) => total + Math.max(0, Number(item?.quantity || 0)), 0)
      : 0;

  const pushCartState = ({ items = [], itemCount } = {}) => {
    const parsedCount = Number(itemCount);
    const resolvedCount = Number.isFinite(parsedCount) ? Math.max(0, parsedCount) : Math.max(0, sumItems(items));

    document.querySelectorAll('.rpd[data-section-id]').forEach((section) => {
      if (!(section instanceof HTMLElement)) return;

      section.dataset.rpdCartItemCount = String(resolvedCount);

      section.dispatchEvent(
        new CustomEvent('rpd:cart-sync', {
          detail: {
            itemCount: resolvedCount,
            items: Array.isArray(items) ? items : [],
          },
        })
      );
    });
  };

  const fetchCart = async () => {
    if (activeRequest) {
      fetchQueued = true;
      return activeRequest;
    }

    activeRequest = fetch(cartUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to refresh cart state');
        return response.json();
      })
      .then((cart) => {
        pushCartState({
          items: cart?.items,
          itemCount: cart?.item_count,
        });
        return cart;
      })
      .catch((error) => {
        console.warn('[NKLV cart sync]', error);
      })
      .finally(() => {
        activeRequest = null;

        if (fetchQueued) {
          fetchQueued = false;
          scheduleFetch(60);
        }
      });

    return activeRequest;
  };

  const scheduleFetch = (delay = 120) => {
    window.clearTimeout(fetchTimer);
    fetchTimer = window.setTimeout(() => {
      fetchCart();
    }, delay);
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event?.promise && typeof event.promise.then === 'function') {
      event.promise
        .then((payload) => {
          const detail = payload?.detail || {};

          if (Array.isArray(detail.items) || Number.isFinite(Number(detail.itemCount))) {
            pushCartState({
              items: detail.items,
              itemCount: detail.itemCount,
            });
          }

          // One authoritative read after Shopify finishes updating/morphing the cart.
          scheduleFetch(120);
        })
        .catch(() => {
          scheduleFetch(180);
        });

      return;
    }

    scheduleFetch(700);
  });

  // Fallback only. If Shopify's normal cart event is missed, refresh after
  // its debounced quantity update has had time to finish.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (
        target.closest(
          'cart-items-component quantity-selector-component button, cart-items-component .quantity-selector button'
        )
      ) {
        scheduleFetch(900);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (
        target.matches(
          'cart-items-component quantity-selector-component input, cart-items-component .quantity-selector input'
        )
      ) {
        scheduleFetch(900);
      }
    },
    true
  );

  window.addEventListener('pageshow', () => scheduleFetch(0));
  document.addEventListener('shopify:section:load', () => scheduleFetch(0));

  fetchCart();
}
